const itemsCategoryType = {
  ITEMS_CATEGORIES_TABLE_STATE_SET: 'ITEMS_CATEGORIES/TABLE_STATE_SET',
  ITEMS_CATEGORY_LIST_SET: 'ITEMS_CATEGORY_LIST_SET',
  CATEGORY_DELETE: 'CATEGORY_DELETE',
};
export default itemsCategoryType;
